import { AppFooter } from '@cub-com-br/theme/app-footer';
import { FC } from 'react';
import { useTenant } from '~/hooks/use-branding';

export const Footer: FC = () => {
  const { companyName, companyLogoUrl, branding } = useTenant();
  const hasCopyrightLine = Boolean(companyName);
  const tenant = hasCopyrightLine ? 'whitelabel' : 'cub';

  return (
    <AppFooter
      // Magic link shares the statement viewer's footer
      app="statement-viewer"
      tenant={tenant}
      copyrightLine={companyName}
      companyLogoSrc={companyLogoUrl}
      partnerColors={{
        secondary: branding?.secondaryColor,
        secondaryContrast: branding?.secondaryContrastColor,
      }}
      showSocialMedia={tenant === 'cub'}
    />
  );
};
